import { ChangeDetectionStrategy, Component, ElementRef, input, model, output, viewChild } from '@angular/core';
import {
  NgbDropdown,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  PlacementArray,
} from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

type BtnSize = 'sm' | 'md' | 'lg' | 'xl';
export type ValueTextPair = { value: any; text: any };
export const toValueTextPair = (valueObject: any, textObject?: any): ValueTextPair => {
  return { value: valueObject, text: textObject ?? valueObject };
};

@Component({
  selector: 'mwe-button-dropdown',
  templateUrl: './button-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbDropdown, NgbDropdownToggle, NgClass, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, TranslatePipe],
})
export class ButtonDropdownComponent {
  placement = input<PlacementArray>('bottom-right');
  buttonSize = input<`btn-${BtnSize}`>('btn-md');
  buttonColor = input<'btn-primary--dark-blue' | 'btn-warning'>('btn-primary--dark-blue');
  ariaLabel = input.required<string>();
  disabled = input<boolean>(false);
  options = input.required<ValueTextPair[]>();
  testAttribute = input<string>('mwe-button-dropdown');
  prefix = input<string>();
  readonly currentValueChange = output<ValueTextPair>();

  btnElement = viewChild<ElementRef<HTMLButtonElement>>('togglebtn');

  currentValue = model.required<ValueTextPair>();

  selectDropdown(dropdownMenuItem: ValueTextPair) {
    this.currentValue.set(dropdownMenuItem);
    this.currentValueChange.emit(dropdownMenuItem);
    this.btnElement().nativeElement.focus();
  }

  isOptionSelected(dropdownMenuItem: ValueTextPair) {
    return dropdownMenuItem.value === this.currentValue().value;
  }
}
